import { type ProductTemplate, type ProductTemplateCreate } from '../entity/api/product-template';
import {
  type CreateProductTemplateRes,
  type DelProductTemplateRes,
  type GetPTemplatesByBrandIdRes,
  type GetProductTemplateRes,
  type ListRes,
  type UpdateProductTemplateRes,
  type UsedByProductsRes,
  createProductTemplateReqSchema,
  delProductTemplateReqSchema,
  getPTemplatesByBrandIdReqSchema,
  updateProductTemplateReqSchema,
  usedByProductsReqSchema,
} from '../entity/api/routes/product-template';
import { apiRequest, setURL } from './request';

export async function getProductTemplateById(id: string) {
  return apiRequest<GetProductTemplateRes>(`/ptemplate/${id}`, 'GET', true);
}

export async function getProductTemplatesList() {
  return apiRequest<ListRes>('/ptemplate/list', 'GET', true);
}

export async function getProductTemplatesByBrandId(brandId: string) {
  const req = getPTemplatesByBrandIdReqSchema.parse({
    params: { id: brandId },
    body: null,
  });
  const url = setURL(`/ptemplate/get-by-brand/${brandId}`, req.query);
  return apiRequest<GetPTemplatesByBrandIdRes>(url, 'GET', true, req.body);
}

export async function createProductTemplate(data: ProductTemplateCreate) {
  const req = createProductTemplateReqSchema.parse({
    params: null,
    body: data,
  });
  const url = setURL('/ptemplate', req.query);
  return apiRequest<CreateProductTemplateRes>(url, 'POST', true, req.body);
}

export async function updateProductTemplate(data: Partial<ProductTemplate>) {
  const { _id: id } = data;
  const req = updateProductTemplateReqSchema.parse({
    params: { id },
    body: data,
  });
  const url = setURL(`/ptemplate/${id}`, req.query);
  return apiRequest<UpdateProductTemplateRes>(url, 'PATCH', true, req.body);
}

export async function usedByProducts(id: string) {
  const req = usedByProductsReqSchema.parse({
    params: { id },
    body: null,
  });
  const url = setURL(`/ptemplate/${id}/is-used-by-products`, req.query);
  return apiRequest<UsedByProductsRes>(url, 'GET', true, req.body);
}

export async function deleteProductTemplate(id: string) {
  const req = delProductTemplateReqSchema.parse({
    params: { id },
    body: null,
  });
  const url = setURL(`/ptemplate/${id}`, req.query);
  return apiRequest<DelProductTemplateRes>(url, 'DELETE', true, req.body);
}
